import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import store from "./store"
import { BrowserRouter } from "react-router-dom"

import "src/styles/fonts.css"
import "src/styles/theme.css"
import "src/styles/cursor.css"
import { i18nReady } from "src/i18n"
import { registerServiceWorker } from "src/utils/serviceWorker"
import CrashScreen from "src/components/CrashScreen"
import App from "./App"

const root = ReactDOM.createRoot(document.getElementById("root"))
// Wait for the player's dictionary (see src/i18n) — `finally`, because a failed fetch of a
// language file should still render the app, in English, rather than nothing.
i18nReady.finally(() => {
  root.render(
    <React.StrictMode>
      {/* Outermost: a render crash anywhere below lands here instead of on a black page. */}
      <CrashScreen>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </CrashScreen>
    </React.StrictMode>
  )
})

// After the first render, not before: registering is what makes the app installable, and it has
// nothing to say to a player who is still waiting for the screen to appear.
registerServiceWorker()
